import { Outlet } from "react-router-dom";

import ViewHeader from "components/ViewHeader";
import ViewHeaderNavigation from "components/ViewHeader/Navigation";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Tab from "ds/components/Tab";
import useTypedContext from "hooks/useTypedContext";
import useCanDeleteTemplate from "shared/Templates/access/useCanDeleteTemplate";

import TemplatesFeatureGateCallout from "../TemplatesWorkbench/FeatureGate/Callout";
import TemplateFeatureGateTooltip from "../TemplatesWorkbench/FeatureGate/Tooltip";
import { TemplateActions } from "../TemplatesWorkbench/FeatureGate/types";
import { TemplateContext } from "./Context";

type PageLayoutProps = {
  onOpenDetailsDrawer: () => void;
  onOpenEditDrawer: () => void;
  onDeleteClick: () => void;
};

const PageLayout = ({ onOpenDetailsDrawer, onOpenEditDrawer, onDeleteClick }: PageLayoutProps) => {
  const { template, templateUrl } = useTypedContext(TemplateContext);
  const canDeleteTemplate = useCanDeleteTemplate();
  const deleteAccess = canDeleteTemplate(template);

  return (
    <>
      <ViewHeader>
        <ViewHeaderWrapper direction="row" justify="between" fullWidth>
          <ViewHeaderWrapper direction="row" align="center">
            <ViewHeaderTitle>{template.name}</ViewHeaderTitle>
          </ViewHeaderWrapper>

          <ViewHeaderWrapper direction="row" align="end" shrink="0">
            <Button variant="secondary" onPress={onOpenDetailsDrawer}>
              Details
            </Button>

            <DropdownMenuEllipsis tooltip="Template actions" dotsSize="medium">
              <TemplateFeatureGateTooltip
                on={(props) => (
                  <DropdownMenuItem {...props} onAction={onOpenEditDrawer}>
                    Edit
                  </DropdownMenuItem>
                )}
                template={template}
                action={TemplateActions.EditTemplate}
                tooltipPlacement="left"
              />

              {(deleteAccess.result || !!deleteAccess.message) && (
                <DropdownMenuItem
                  key="delete"
                  onAction={onDeleteClick}
                  danger
                  isDisabled={!deleteAccess.result}
                  tooltip={deleteAccess.message}
                  tooltipPlacement="left"
                >
                  Delete
                </DropdownMenuItem>
              )}
            </DropdownMenuEllipsis>
          </ViewHeaderWrapper>
        </ViewHeaderWrapper>

        <ViewHeaderNavigation>
          <Tab end to={templateUrl} label="Versions" />
          <Tab to={`${templateUrl}/deployments`} label="Deployments" />
        </ViewHeaderNavigation>
      </ViewHeader>
      <TemplatesFeatureGateCallout />
      <Outlet />
    </>
  );
};

export default PageLayout;
